module.exports = __webpack_public_path__ + "media/images/menu/m6-1074d674b3fd4bca3894c073974af042.JPG";